import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '@lib/shared-interface-school';
import * as Case from 'case';

@Pipe({
    standalone: true,
    name: 'libNamedLocation',
})
export class NamedLocationPipe implements PipeTransform {
    public transform(namedLocation: NamedLocation): string {
        const descriptions = [...generateDescriptions(namedLocation)];
        return descriptions.join(' ');
    }
}

function* generateDescriptions(namedLocation: NamedLocation): Generator<string> {
    const { location } = namedLocation;
    const name = namedLocation.name ? Case.title(namedLocation.name) : undefined;

    if (name) yield name;
    if (location) {
        const city = location.city ? Case.title(location.city) : undefined;
        const state =
            location.state == undefined
                ? undefined
                : location.state.length >= 2
                  ? location.state.toUpperCase()
                  : Case.title(location.state);
        const prefix = name ? 'in ' : '';

        if (city && state) return yield `${prefix}${city}, ${state}`;
        if (city || state) return yield `${prefix}${city || state}`;

        yield '';
    }
}

type NamedLocation = {
    name?: string;
    location?: Pick<Address, 'city' | 'state'>;
};
